import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { PageHeader, OwnerNote } from "../components/Layout";
import { api, errMsg } from "../lib/api";

const EMPTY = { name: "", email: "", subject: "", message: "", website: "" };

export default function Contact() {
  const [v, setV] = useState(EMPTY);
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/contact", v);
      setSent(true);
      setV(EMPTY);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow="Kontakt" title="Skriv til VetPris">Spørgsmål, rettelser til priser eller henvendelser fra klinikker – vi svarer så hurtigt som muligt.</PageHeader>
      <div className="container-vp py-12 max-w-2xl">
        <div className="mb-6"><OwnerNote testid="contact-owner" /></div>
        {sent ? (
          <div className="card-vp p-8 text-center" data-testid="contact-success">
            <CheckCircle2 className="h-10 w-10 text-[#087F72] mx-auto" />
            <h2 className="text-xl font-bold text-[#153C3A] mt-3">Tak for din besked</h2>
            <p className="text-sm text-[#52706D] mt-2">Vi har modtaget din henvendelse.</p>
            <button className="btn-outline mt-5" onClick={() => setSent(false)} data-testid="contact-send-another">Send en ny besked</button>
          </div>
        ) : (
          <form onSubmit={submit} className="card-vp p-6 grid gap-4" data-testid="contact-form">
            {[["name", "Navn", "text"], ["email", "E-mail", "email"], ["subject", "Emne", "text"]].map(([k, l, t]) => (
              <div key={k}><label htmlFor={`c-${k}`} className="block text-xs font-semibold text-[#52706D] mb-1.5">{l} *</label>
                <input id={`c-${k}`} type={t} required className="field-vp" value={v[k]} onChange={set(k)} data-testid={`contact-${k}-input`} /></div>
            ))}
            <div><label htmlFor="c-message" className="block text-xs font-semibold text-[#52706D] mb-1.5">Besked * (mindst 10 tegn)</label>
              <textarea id="c-message" required minLength={10} rows={6} className="field-vp h-auto py-2" value={v.message} onChange={set("message")} data-testid="contact-message-input" /></div>
            <input type="text" tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" value={v.website} onChange={set("website")} />
            <button className="btn-primary justify-self-start" disabled={busy} data-testid="contact-submit-button">{busy ? "Sender…" : "Send besked"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
